<template>
  <div class="page">
    <Header title="我的" :showBack="false" />
    <div class="center-head-portrait">
      <img :src="getAvatar(avatarImageUri)" />
      <div class="center-user-info">
        <div class="center-user-info-name">{{userInfo.clientUserDTO&&userInfo.clientUserDTO.userName}}<span
            class="verifyStatus" v-if="userInfo.verifyStatus==='01'">({{userInfo.verifyStatusName}})</span></div>
        <div class="center-user-info-mobile">
          {{userInfo.clientUserDTO&&userInfo.clientUserDTO.userRoleName}}-{{userInfo.clientUserDTO&&userInfo.clientUserDTO.userMobile}}
        </div>
      </div>
      <div>

      </div>
      <!-- <img class="center-head-portrait-wrapper" :src="$getImgUrl('/wx-app-v2/img/head-portrait-wrapper.png')" alt=""> -->
      <!-- <img class="center-head-portrait-icon" src="{{avatarImageUri}}" style="border-radius: 50%;"> -->
    </div>

    <div class="center-info">
      <div class="center-info-item center-integration-coupon green-shadow">
        <div class="center-integration-coupon-item center-integration-border" @click="toUserIntegration()"
          v-for="(point,index) in pointList" :key="index">
          <div class="center-integration-coupon-num">{{point.pointValue}}积分</div>
          <div class="center-integration-coupon-title themecolor">{{point.pointTypeName}}</div>
        </div>
        <div class="center-integration-coupon-item" @click="toUserCoupon()" v-if="$store.state.user.userRole!=='03'">
          <div class="center-integration-coupon-num">{{couponListLength}}张</div>
          <div class="center-integration-coupon-title themecolor">我的卡券</div>
        </div>
      </div>

      <div class="center-info-item center-item-box green-shadow">
        <van-cell is-link to="/center/personal-data">
          <template #title>
            <span class="custom-title">个人资料</span>
          </template>
        </van-cell>
        <van-cell is-link @click="qrCodeOverlay = true" v-if="$store.state.user.userRole==='01'">
          <template #title>
            <span class="custom-title">修理厂名片</span>
          </template>
        </van-cell>
      </div>

      <div class="center-info-item center-item-box green-shadow" v-if="$store.state.user.userRole==='01'">
        <van-cell is-link to="/center/workshop-change" v-if="clientListLength>1">
          <template #title>
            <span class="custom-title">切换修理厂</span>
          </template>
        </van-cell>
        <van-cell is-link to="/center/staff-info">
          <template #title>
            <span class="custom-title">员工账号管理<span v-if="applyLength>0"
                class="message_tip">{{applyLength}}</span></span>
          </template>
          <template #default>
            <!-- <div class="message_tip">122</div> -->
          </template>
        </van-cell>
      </div>

      <div class="center-info-item center-item-box green-shadow">
        <van-cell is-link to="/userOrder" v-if="$store.state.user.userRole!=='03'">
          <template #title>
            <span class="custom-title">订单中心</span>
          </template>
        </van-cell>
        <van-cell is-link to="/receivingAddress" v-if="$store.state.user.userRole!=='03'">
          <template #title>
            <span class="custom-title">收货地址</span>
          </template>
        </van-cell>
        <van-cell is-link to="/userCollection">
          <template #title>
            <span class="custom-title">我的收藏</span>
          </template>
        </van-cell>
        <van-cell is-link to="/subordinate/management" v-if="subClientCount > 0">
          <template #title>
            <span class="custom-title">下级管理</span>
          </template>
        </van-cell>
        <van-cell is-link to="/quality-assurance-ws">
          <template #title>
            <span class="custom-title">电子质保</span>
          </template>
        </van-cell>
        <van-cell is-link @click="toUserService">
          <template #title>
            <span class="custom-title">客服热线</span>
          </template>
        </van-cell>
        <van-cell is-link to="/help-center">
          <template #title>
            <span class="custom-title">帮助中心</span>
          </template>
        </van-cell>
      </div>
      <div class="center-info-item center-item-box green-shadow" v-if="marketName!=='SAH'">
        <van-cell is-link to="/manual">
         <template #title>
            <span class="custom-title">用户手册</span>
          </template>
          <!-- <template #title>
            <a class="custom-title" :href="fileServer+'/static/pdf/易加网操作指南手机端.pdf'" target="_blank">易加网操作指南手机端</a>
          </template> -->
        </van-cell>
      </div>
      <div class="center-info-item green-shadow">
        <div class="logout-btn" @click="handleLogout()">退出登录</div>
      </div>
      <div class="block"></div>
    </div>

    <van-overlay :show="qrCodeOverlay" @click="qrCodeOverlay = false">
      <div class="qrCode_box_overlay">
        <img class="qrCode_box_bg" :src="$getImgUrl('/wx-app-v2/img/center/workshop-qrcode-bg.png')" />
        <div class="worker-info-item">
          <img :src="getAvatar(avatarImageUri)" class="head-portrait" />
          <div class="worker-info-detail">
            <div class="worker-info-detail-name">
              {{userInfo.clientUserDTO&&userInfo.clientUserDTO.userName}}-{{userInfo.clientUserDTO&&userInfo.clientUserDTO.userMobile}}
            </div>
            <div class="worker-info-detail-point">
              {{userInfo.provinceName+userInfo.cityName+userInfo.countyName+userInfo.detailAddress}}</div>
            <div class="worker-info-detail-role">{{userInfo.clientUserDTO&&userInfo.clientUserDTO.userRoleName}}</div>
          </div>
        </div>
        <div class="client_name">{{userInfo.clientName}}</div>
        <div class="qrcode-box">
          <div class="qrcode-wrap" ref="qrCode">
            <div id="qrcode"></div>
          </div>
        </div>
      </div>
    </van-overlay>

    <tabbar :active="3"></tabbar>
  </div>
</template>

<script>
import Header from '@/components/header'
import { userUtils, loginUtils } from '@/utils/auth'
import { commonUtils } from '@/utils/common'
import { localStorageUtils } from '@/utils/localstorage'

import centerApi from '@/api/center'
import couponApi from '@/api/coupon'
import ssoLoginApi from '../../api/sso-login'
import Tabbar from '../../components/tabbar.vue'
import QRCode from 'qrcodejs2'
import { mapState } from 'vuex'
export default {
  components: {
    Header,
    Tabbar
  },
  data () {
    return {
      pointList: [],
      couponListLength: 0,
      userInfo: {},
      avatarImageUri: '',
      clientListLength: 1,
      qrCodeOverlay: false,
      qrcodeUrl: '',
      subClientCount: 0,
      marketName: ''
      // applyLength: 0
    }
  },
  computed: {
    ...mapState({
      clientApplyList: state => state.user.clientApplyList,
      applyLength: state => state.user.applyLength,
      clientInfo: state => state.user.clientInfo
    })
  },
  created () {
    this.init()
    this.marketName = this.clientInfo.marketName
  },
  methods: {
    getAvatar (img) {
      return commonUtils.getImageUrl(img)
    },
    init () {
      this.queryPointList()
      this.getClientInfo()
      this.queryCouponList()
      this.getApplyLength()
    },
    async getClientInfo () {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      centerApi.clientQueryClientCount().then(res => {
        if (res.data.resultCode === '0') {
          this.clientListLength = res.data.resultData.clientCount
          console.log(this.clientListLength, 'this.clientListLength')
        }
      }).catch(() => { })
      // 获取跳转的链接
      let { data } = await centerApi.getClientInfo()
      this.$toast.clear()
      this.userInfo = data.resultData.clientInfo
      this.subClientCount = data.resultData.clientInfo.subClientCount
      this.avatarImageUri = this.userInfo.avatarImageUri
      let clientId = data.resultData.clientInfo.clientId
      this.qrcodeUrl = `${document.location.origin}/v2/register2?clientId=${clientId}&applyType=04`
      console.log(this.qrcodeUrl, 'this.qrcodeUrl')
      this.$nextTick(() => {
        this.crateQrcode()
      })
    },
    queryPointList () {
      centerApi.queryPointList().then(res => {
        if (res.data.resultCode === '0') {
          this.pointList = res.data.resultData.pointList
        }
      })
    },
    getApplyLength () {
      let params = {
        approveStatus: '01'
      }
      this.$store.dispatch('getClientApplyList', params).then(response => {})
      // centerApi.queryClientUserApplyList(params).then(res => {
      //   if (res.data.resultCode === '0') {
      //     this.applyLength = res.data.resultData && res.data.resultData.clientApplyList && res.data.resultData.clientApplyList.length
      //   }
      // })
    },
    queryCouponList () {
      couponApi.getCouponList().then(res => {
        if (res.data.resultCode === '0') {
          this.couponListLength = res.data.resultData.couponTotal || 0
        }
      })
    },
    toUserIntegration () {
      this.$router.push({ name: 'user-integration' })
    },
    toUserCoupon () {
      this.$router.push({ name: 'userCoupon' })
    },
    handleLogout () {
      ssoLoginApi.authLogout().then(res => {
        if (res.data.resultCode === '0') {
          console.log('111')
          this.$toast('登出成功！')
          userUtils.removeUserLocal()
          this.$store.commit('setClientInfo', {})
          let ssoToken = localStorageUtils.get('ssoToken') || ''
          if (ssoToken) {
            loginUtils.ssoLogout(ssoToken)
            localStorageUtils.remove('ssoToken')
          } else {
            this.$router.push({ name: 'login2' })
          }
          this.$toast.clear()
        }
      })
    },
    toUserService () {
      window.location.href = 'tel:400 000 5109'
    },
    // 生成二维码
    crateQrcode () {
      this.qr = new QRCode('qrcode', {
        width: 170,
        height: 170,
        text: this.qrcodeUrl,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    }
  }
}
</script>

<style scoped lang="less">

/* 头像 */
.center-head-portrait{
    position: relative;
    width: 100%;
    height: 100px;
    display: flex;
    vertical-align: middle;
    img{
      margin: 20px 0 0 10px;
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }
    .center-user-info{
      margin: 30px 0 0 10px;
    }
    .center-user-info-name{
      font-size: 18px;
      line-height: 32px;
    }
    .center-user-info-mobile{
      color: rgb(175, 175, 175);
    }
}
.center-head-portrait .center-head-portrait-bg{
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 9;
}
.center-head-portrait .center-head-portrait-wrapper{
    position: absolute;
    top: 50%;
    left: 50%;
    width: 3.25rem;
    height: 3.25rem;
    -webkit-transform: translate(-50%,-50%);
            transform: translate(-50%,-50%);
    z-index: 10;
}
.center-head-portrait .center-head-portrait-icon{
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1.95rem;
    height: 1.95rem;
    -webkit-transform: translate(-50%,-50%);
            transform: translate(-50%,-50%);
    z-index: 10;
}

/* 卡券积分 */
.center-info{
  margin: 0 10px;
  width: calc(100% - 20px);
}
.center-info-item{
  margin-top: 15px;
  padding-top: 0.1rem;
  padding-bottom: 0.06rem;
  background-color: #fff;
  // display: flex;
  // justify-content: space-evenly;
  // height: 60px;
  // line-height: 20px;
  // align-items: center;
  // text-align: center;
  //border-bottom: 5px solid #65bac7;
  border-radius: 5px;
}
.center-integration-coupon{
    padding-top: 0.1rem;
    padding-bottom: 0.06rem;
    background-color: #fff;
    display: flex;
    justify-content: space-evenly;
    height: 60px;
    line-height: 20px;
    align-items: center;
    text-align: center;
}
.center-integration-coupon-item{
  flex:1;
}
.center-integration-border{
  border-right: 1px solid #f1f1f1;
}
.center-integration-coupon-title{
    font-size:14px;
    color: #117281;
}
.center-integration-coupon-num{
    color: #e41b2c;
    font-size: 0.3rem;
}
.center-item-box{
  align-items: center;
  vertical-align: middle;
  img{
    position: absolute;
    top: 12px;
    width: 18px;
    margin-right: 10px;
  }
  .custom-title{
    padding-left: 10px;
  }
}

.logout-btn{
  text-align: center;
  line-height: 40px;
}
.block{
  width: 100%;
  height: 56px;
}
.qrCode_box_overlay{
  width: 90%;
  margin-left: 5%;
  margin-top:100px;
}
.qrCode_box_bg{
  width: 90%;
  position: absolute;
  z-index: 1;
}
.worker-info-item{
  position: relative;
  border-radius: 5px;
  display: flex;
  z-index: 5;
  top: 10px;
  .head-portrait{
    width: 80px;
    height: 80px;
    margin: 10px 10px 10px 25px;
    border-radius: 5px;
    vertical-align: middle;
    border-radius: 10px;
  }
  .worker-info-detail{
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    margin-top: 5px;
  }
  .worker-info-detail-name{
    font-size: 16px;
    color: black;
    width: calc(100vw - 160px - 5%);
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .worker-info-detail-point{
    color: grey;
    font-size: 12px;
    width: calc(100vw - 160px - 5%);
  }
  .worker-info-detail-role{
    text-align: center;
    font-size: 12px;
    padding: 2px;
    width: 40px;
    background-color: #f7d8de;
    border-radius: 5px;
    color: #cd1231;
  }
}
.qrcode-box {
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  box-sizing: border-box;
  position: relative;
  z-index: 5;
  margin-top: 30px;
}
.qrcode-wrap {
  width: 100%;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.client_name{
  margin-top: 40px;
  color: var(--base-green);
  font-size: 20px;
  font-weight: 600;
  position: relative;
  z-index: 5;
  text-align: center;
}
.verifyStatus{
  color: rgb(238, 1, 1);
  font-size: 14px;
  margin-left: 5px;
}
.message_tip{
  color: white;
  background-color: red;
  border-radius: 50%;
  height: 22px;
  font-size: 12px;
  text-align: center;
  padding: 0 4px;
  margin-left: 2px;
}
</style>
